import { SIGN_IN_RESET, SIGN_IN_OK, SIGN_IN_FAILURE } from '../actions/types';

const INITIAL_STATE = {
    result: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SIGN_IN_RESET:
            return { ...state, result: null };
        case SIGN_IN_OK:
            return { ...state, result: true };
        case SIGN_IN_FAILURE:
            return { ...state, result: false };
        default:
            return state;
    }
};
